// Hook chargeant les séries + sets, et exposant la liste ordonnée
// (ordre Pokécardex) pour la grille principale.

import { useState, useEffect, useCallback, useMemo } from "react";
import { fetchSeriesWithSets, refreshSeriesWithSets } from "../lib/api";
import { BLOC_ORDER, SATELLITE_SET_IDS } from "../config/blocs";

export function useSeriesData() {
  const [seriesData, setSeriesData] = useState([]);
  const [loading, setLoading] = useState(true);

  const reload = useCallback(async () => {
    try {
      setLoading(true);
      setSeriesData(await fetchSeriesWithSets());
    } catch (err) {
      console.error("Error fetching series:", err);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { reload(); }, [reload]);

  // Rafraîchissement manuel : le backend rebâtit sa liste depuis TCGdex puis
  // nous la renvoie — inutile de refaire un GET derrière.
  const [refreshing, setRefreshing] = useState(false);
  const refresh = useCallback(async () => {
    setRefreshing(true);
    try {
      const data = await refreshSeriesWithSets();
      setSeriesData(data.series || []);
      return data;
    } finally {
      setRefreshing(false);
    }
  }, []);

  // Sets ordonnés comme Pokécardex (les connus d'abord, puis le reste).
  // Les sous-sets satellites (Galerie de Dresseurs/Galaroise) sont exclus :
  // fusionnés dans leur set principal côté backend, jamais une tuile à part
  // sur la page d'accueil.
  const orderedSets = useMemo(() => {
    const allSets = seriesData.flatMap(s => s.sets || []).filter(s => !SATELLITE_SET_IDS.has(s.id));
    const setById = {};
    allSets.forEach(s => { setById[s.id] = s; });
    const known = BLOC_ORDER.flatMap(b => b.setIds)
      .map(id => setById[id]).filter(Boolean);
    const knownIds = new Set(known.map(s => s.id));
    const other = allSets.filter(s => !knownIds.has(s.id));
    return [...known, ...other];
  }, [seriesData]);

  return { seriesData, orderedSets, loading, refresh, refreshing };
}
